let NOTIFICATION_SYSTEM = null;
export function setupNotificationSystem(notificationSystem) {
    NOTIFICATION_SYSTEM = notificationSystem;
}

export function addNotification(notification) {
    NOTIFICATION_SYSTEM.addNotification(notification);
}



// WEBPACK FOOTER //
// ./src/notifications.js